export enum ClaimsState {
    oneClaim = 'Only one claim',
    twoClaims = 'Full module two claims',
    noClaims = 'Opt/in - Empty state'
}
